import { X } from 'lucide-react';
import css from './clear-field-button.module.scss';

// The "X" affordance that empties a text-ish field, designed to be passed into
// `Input`'s `trailingIcon` slot. Callers render it conditionally — only while
// the field actually has a value — so an empty input stays visually clean.
//
// A real <button> rather than a bare clickable <X/> icon (the older shape in
// DateRangePicker / MultiSelect): that makes it screen-reader labelled and
// exempt from the surrounding form's submit behaviour via `type="button"`.
// `tabIndex={-1}` keeps Tab moving between fields instead of stopping on every
// clear icon — the field is still clearable from the keyboard by
// selecting-and-deleting, so no capability is lost.

type ClearFieldButtonProps = {
  // Full accessible label, e.g. "Clear Title filter". Pass something
  // field-specific so several on one row stay distinguishable.
  label: string;
  onClear: () => void;
  size?: number;
};

export const ClearFieldButton = ({
  label,
  onClear,
  size = 12,
}: ClearFieldButtonProps) => (
  <button
    aria-label={label}
    className={css.root}
    onClick={onClear}
    tabIndex={-1}
    title={label}
    type="button"
  >
    <X size={size} />
  </button>
);
